import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqs } from '../../mock/mockData';

export const Faq = () => (
  <section id="faq" className="mx-auto max-w-3xl px-6 py-24 md:px-12 md:py-32">
    <div className="text-center">
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">Good to know</p>
      <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">Questions, answered</h2>
    </div>
    <Accordion type="single" collapsible className="mt-12">
      {faqs.map((faq) => (
        <AccordionItem key={faq.id} value={`item-${faq.id}`} className="border-b border-border">
          <AccordionTrigger className="py-5 text-left font-display text-lg font-semibold tracking-tight hover:text-primary hover:no-underline">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-base leading-relaxed text-muted-foreground">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
